import React from "react";

const RemovedHoldBanner = () => (
  <div className="fw-bg">
    <div className="center remove-hold-banner color-sunshine-1-bg">
      Welcome back! Your hold was removed. Start adding new styles to your wish list.
    </div>
  </div>
);

export default RemovedHoldBanner;
